import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Select } from 'antd';

import { withTranslation } from 'language/i18n';
import { BUYING_FORMAT, MACHINE_STATE } from 'constants/common';
import MobileActions from './MobileActions';

const { Option } = Select;

const Actions = ({
  t, setMobileFilterVisible, selectedFilters, onFilter, filters,
}) => {
  const getDefaultSortValue = () => {
    const sortType = _.result(selectedFilters, 'sort');
    if (sortType) {
      return sortType[0];
    }

    return 'eventCloseToEndDate';
  };

  const isSelected = (object, value) => {
    if (
      (_.isEmpty(selectedFilters) && value === MACHINE_STATE.IN_EVENT)
      || (_.isEmpty(selectedFilters) && value === '')
      || (_.includes(selectedFilters, object, undefined) && value === MACHINE_STATE.IN_EVENT)
      || (_.includes(selectedFilters, object, undefined) && value === '')
    ) {
      return true;
    }
    const selected = _.includes(selectedFilters[object], value);
    return selected;
  };

  const getTabCount = (state) => {
    const saleState = _.find(filters.saleStates, ['selector', state]);
    return saleState ? saleState.count : 0;
  };

  return (
    <div className="row mb-3">
      <div className="col">
        <div className="list-actions">
          <div className="row">
            <div className="col">
              <nav className="im-tabs im-tabs--horizontal-bar-type2">
                <a className={`im-tabs__tab ${isSelected('state', MACHINE_STATE.IN_EVENT) && 'im-tabs__tab--active'}`} onClick={() => onFilter({ name: 'state', value: MACHINE_STATE.IN_EVENT })}>
                  {`${t('onSale')} (${getTabCount(MACHINE_STATE.IN_EVENT)})`}
                </a>
                <a className={`im-tabs__tab ${isSelected('state', MACHINE_STATE.WAITING_EVENT_DATE) && 'im-tabs__tab--active'}`} onClick={() => onFilter({ name: 'state', value: MACHINE_STATE.WAITING_EVENT_DATE })}>
                  {`${t('comingSoon')} (${getTabCount(MACHINE_STATE.WAITING_EVENT_DATE)})`}
                </a>
                <a className={`im-tabs__tab ${isSelected('state', MACHINE_STATE.SOLD) && 'im-tabs__tab--active'}`} onClick={() => onFilter({ name: 'state', value: MACHINE_STATE.SOLD })}>
                  {`${t('sold')} (${getTabCount(MACHINE_STATE.SOLD)})`}
                </a>
              </nav>
            </div>
          </div>

          <div className="im-box im-box--white im-box--fluid im-box--shadow p-3 p-lg-4">
            <div className="row align-items-center d-none d-lg-flex">
              <div className="col">
                <div className="im-button-group">
                  <a
                    className={`im-button im-button--gutter-20 im-button--size-40 im-button--outline-less-tickness im-button--outline-gray-yellow-t2 ${isSelected('format', '') && 'active'}`}
                    onClick={() => onFilter({ name: 'format', value: '' })}
                  >
                    {t('all')}
                  </a>
                  {/* <a
                    className={`im-button im-button--gutter-20 im-button--size-40 im-button--outline-less-tickness im-button--outline-gray-yellow-t2 ${isSelected('format', BUYING_FORMAT.BID) && 'active'}`}
                    onClick={() => onFilter({ name: 'format', value: BUYING_FORMAT.BID })}
                  >
                    {t('auction')}
                  </a> */}
                  <a
                    className={`im-button im-button--gutter-20 im-button--size-40 im-button--outline-less-tickness im-button--outline-gray-yellow-t2 ${isSelected('format', BUYING_FORMAT.OFFER) && 'active'}`}
                    onClick={() => onFilter({ name: 'format', value: BUYING_FORMAT.OFFER })}
                  >
                    {t('makeOffer')}
                  </a>
                  <a
                    className={`im-button im-button--gutter-20 im-button--size-40 im-button--outline-less-tickness im-button--outline-gray-yellow-t2 ${isSelected('format', BUYING_FORMAT.BUY_NOW) && 'active'}`}
                    onClick={() => onFilter({ name: 'format', value: BUYING_FORMAT.BUY_NOW })}
                  >
                    {t('buyNow')}
                  </a>
                </div>
              </div>
              <div className="col-auto">
                <Select
                  name="sort"
                  placeholder=""
                  onChange={(value) => onFilter({ name: 'sort', value })}
                  value={getDefaultSortValue()}
                  style={{ width: 200 }}
                >
                  <Option value="az">A-Z</Option>
                  <Option value="za">Z-A</Option>
                  <Option value="cheapToExpensive">Fiyata Göre Artan</Option>
                  <Option value="expensiveToCheap">Fiyata Göre Azalan</Option>
                  <Option value="eventFarToEndDate">Bitiş Tarihi En Uzak</Option>
                  <Option value="eventCloseToEndDate">Bitiş Tarihi En Yakın</Option>
                  <Option value="youngToOld">Yeniden Eskiye</Option>
                  <Option value="oldToYoung">Eskiden Yeniye</Option>
                </Select>
              </div>
            </div>
            <MobileActions
              setMobileFilterVisible={setMobileFilterVisible}
              selectedFilters={selectedFilters}
              onFilter={onFilter}
              getDefaultSortValue={getDefaultSortValue}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Actions.propTypes = {
  t: PropTypes.func,
  setMobileFilterVisible: PropTypes.func,
  selectedFilters: PropTypes.object,
  onFilter: PropTypes.func,
  filters: PropTypes.object,
};

export default withTranslation('common')(Actions);
